/** Единые подписи для пустых полей и списков в карточках контрагента / перевозчика / маршрута */

export const EMPTY_FIELD = 'Не указано';

export function emptyListMessage(entityPlural: string): string {
  return `Пока нет ${entityPlural}`;
}

export function innSubtitleLine(inn: string | null | undefined): string {
  const t = inn?.trim();
  return t ? `ИНН ${t}` : 'ИНН не указан в карточке';
}
